import { EActiveView } from '../../types/view';
export var defaultState = {
  active: EActiveView.AuthenticationRegistration
};